import _styled, { default as _styled2 } from "styled-components";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@adsk/alloy-react-tooltip';
import { AlertInformationIcon } from '@adsk/alloy-react-icon';
import { labelStyle as defaultLabelStyle, requiredStyle, tooltipIconStyle } from './styles';
var Label = function Label(_ref) {
  var text = _ref.text,
    required = _ref.required,
    tooltipMessage = _ref.tooltipMessage,
    delayTooltipHide = _ref.delayTooltipHide,
    size = _ref.size,
    labelStyle = _ref.labelStyle;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: defaultLabelStyle,
    $_css2: labelStyle
  }, /*#__PURE__*/React.createElement("div", null, text), required && /*#__PURE__*/React.createElement(_StyledDiv2, null, "\xA0*"), tooltipMessage && /*#__PURE__*/React.createElement(Tooltip, {
    shouldWrapChildren: false,
    content: tooltipMessage,
    placement: Tooltip.PLACEMENTS.RIGHT,
    delayHide: delayTooltipHide ? 1000 : 0
  }, /*#__PURE__*/React.createElement(AlertInformationIcon, {
    size: size,
    style: tooltipIconStyle
  })));
};
Label.propTypes = {
  delayTooltipHide: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  labelStyle: PropTypes.object,
  required: PropTypes.bool,
  size: PropTypes.number,
  text: PropTypes.string.isRequired,
  tooltipMessage: PropTypes.node
};
Label.defaultProps = {
  delayTooltipHide: false,
  required: false,
  size: 16,
  labelStyle: {}
};
export default Label;
var _StyledDiv = _styled("div")(function (p) {
  return _objectSpread(_objectSpread({}, p.$_css), p.$_css2);
});
var _StyledDiv2 = _styled2("div").withConfig({
  displayName: "component___StyledDiv2",
  componentId: "sc-1rmjeys-0"
})(["", ""], requiredStyle);
//# sourceMappingURL=component.js.map